export const numberFormat = (n?: string | number | null, c?: number) => {
  const digits = typeof c === 'number' ? c : 2
  return (Number(n) || 0).toLocaleString(undefined, {
    maximumFractionDigits: digits,
    minimumFractionDigits: digits,
  })
}
